export default __webpack_public_path__ + "static/media/Img.422c8c3f.jpg";